import { Mutex } from './mutex';

export enum StaticMutexKeys {
  STOREFRONT_CART = 'storefront-cart',
  MANUAL_FG_CONFIG = 'manual-fg-config',
  AUTO_FG_CONFIG = 'auto-fg-config',
  FREEGIFT = 'freegift',
  CVB = 'cvb',
  SHIP_PRO = 'ship-pro',
  CART_MODIFY = 'cart-modify',
  PDP_POPUP = 'pdp-popup',
}

export class MutexManager {
  private static instance: MutexManager;

  private mutexes: { [name: string]: Mutex };

  private constructor() {
    this.mutexes = {};
  }

  static getInstance(): MutexManager {
    if (!MutexManager.instance) {
      MutexManager.instance = new MutexManager();
    }
    return MutexManager.instance;
  }

  getMutex(name: string): Mutex {
    if (!this.mutexes[name]) {
      this.mutexes[name] = new Mutex();
    }
    return this.mutexes[name];
  }
}

export const mutexManager = MutexManager.getInstance();
